
import { API_ENDPOINT, httpService } from "../core/services/http.service";

export class NewsletterService {
    private readonly API_PATH = '/newsletter/'

    async subscribe(email: string, nlId: string): Promise<any> {
        try {
            if (!nlId) { throw new Error("NlId not provided") }

            let options = {
                method: 'POST',
                body: JSON.stringify(email ? { email } : {})
            };

            const response = await httpService.query(`${API_ENDPOINT}${this.API_PATH}${nlId}`, options)
            if (!response.ok) { 
                const errorData = await response.json()
                throw new Error(errorData.error || response.statusText) 
            }

            return response.json()
        }
        catch (error: any) {
            console.log(error)
            throw error
        }
    }
}

export const newsletterService = new NewsletterService()